module.exports = __webpack_public_path__ + "static/media/contacts.bad81aee.png";